import catalog from '../locales/en/catalog.json';
import common from '../locales/en/common.json';
import companyAddressTable from '../locales/en/company-address-table.json';
import companyContactTable from '../locales/en/company-contact-table.json';
import createCustomerAddressForm from '../locales/en/create-customer-address-form.json';
import createCustomerContactForm from '../locales/en/create-customer-contact-form.json';
import customerDetail from '../locales/en/customer-detail.json';
import customersList from '../locales/en/customers-list.json';
import dashboard from '../locales/en/dashboard.json';
import events from '../locales/en/events.json';
import explorer from '../locales/en/explorer.json';
import filters from '../locales/en/filters.json';
import genericList from '../locales/en/generic-list.json';
import insightsTriage from '../locales/en/insights-triage.json';
import insights from '../locales/en/insights.json';
import lineItemTable from '../locales/en/line-item-table.json';
import notes from '../locales/en/notes.json';
import opportunities from '../locales/en/opportunities.json';
import orderLineStatus from '../locales/en/order-line-status.json';
import orderStatus from '../locales/en/order-status.json';
import presetDatePicker from '../locales/en/preset-date-picker.json';
import productDetails from '../locales/en/product-details.json';
import quotesOrdersActions from '../locales/en/quotes-orders-actions.json';
import quotesOrdersHeader from '../locales/en/quotes-orders-header.json';
import quotesOrdersLineActions from '../locales/en/quotes-orders-line-actions.json';
import quotesOrdersLineItems from '../locales/en/quotes-orders-line-items.json';
import quotesOrdersList from '../locales/en/quotes-orders-list.json';
import quotes from '../locales/en/quotes.json';
import reorders from '../locales/en/reorders.json';
import salesDraft from '../locales/en/sales-draft.json';
import salesHistory from '../locales/en/sales-history.json';
import tableCommon from '../locales/en/table-common.json';
import tableProductAvailibity from '../locales/en/table-product-availibity.json';
import tableProductSalesHistory from '../locales/en/table-product-sales-history.json';
import tapiIntegration from '../locales/en/tapi-integration.json';
import tasks from '../locales/en/tasks.json';
import toasts from '../locales/en/toasts.json';
import transactionDetails from '../locales/en/transaction-details.json';

export const enTranslations = {
    catalog: catalog,
    common: common,
    'company-address-table': companyAddressTable,
    'company-contact-table': companyContactTable,
    'create-customer-address-form': createCustomerAddressForm,
    'create-customer-contact-form': createCustomerContactForm,
    'customer-detail': customerDetail,
    'customers-list': customersList,
    dashboard: dashboard,
    explorer: explorer,
    filters: filters,
    'generic-list': genericList,
    insights: insights,
    'insights-triage': insightsTriage,
    'line-item-table': lineItemTable,
    notes: notes,
    opportunities: opportunities,
    'preset-date-picker': presetDatePicker,
    'product-details': productDetails,
    quotes: quotes,
    'quotes-orders-actions': quotesOrdersActions,
    'quotes-orders-header': quotesOrdersHeader,
    'quotes-orders-line-actions': quotesOrdersLineActions,
    'quotes-orders-line-items': quotesOrdersLineItems,
    'quotes-orders-list': quotesOrdersList,
    reorders: reorders,
    'sales-draft': salesDraft,
    'sales-history': salesHistory,
    'table-common': tableCommon,
    'table-product-availibity': tableProductAvailibity,
    'table-product-sales-history': tableProductSalesHistory,
    'tapi-integration': tapiIntegration,
    tasks: tasks,
    toasts: toasts,
    'transaction-details': transactionDetails,
    events: events,
    'order-line-status': orderLineStatus,
    'order-status': orderStatus,
};
